import { useCallback, useContext, useLayoutEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { warningToast } from '../../store/slices/toaster.slice';
import { STATUS } from '../../constants/status.constant';
import { RequestContext } from '../../context/Request.context';
import { useRequestList } from '../../context/RequestList.context';

export const RequestDataWrapper = (props) => {
  const { requestId } = useParams();
  const navigate = useNavigate();

  const { list, isLoading } = useRequestList();

  const { t: common } = useTranslation('common');
  const { children } = props;
  const { updateRequestField, setLoading } = useContext(RequestContext);

  const cantFindToast = useCallback(() => {
    warningToast(common('errors.cantFindRequestC'), common('errors.cantFindRequestT'));
    setLoading(false);
    navigate(props.redirect);
  }, [common, navigate, props.redirect, setLoading]);

  useLayoutEffect(() => {
    if (isLoading) {
      return;
    }

    if (!requestId) {
      cantFindToast();
      return;
    }

    if (requestId) {
      setLoading(true);
      const item = list.find((item) => item.case_id === requestId);

      if (!item) {
        cantFindToast();
        return;
      }

      if (item.status !== STATUS.APPROVED) {
        warningToast(common('errors.notEditableRequestC'), common('errors.notEditableRequestT'));
        navigate(props.redirect);
        return;
      }

      updateRequestField(item);
      setLoading(false);
    }
  }, [common, list, isLoading, cantFindToast, setLoading, requestId, updateRequestField, navigate, props.redirect]);

  return children;
};

export default RequestDataWrapper;
